<div class="flex flex-row justify-between gap-4" [formGroup]="contactForm">
    <select formControlName="isoCode" name="isoCode" #country (change)="onIsoChange(country.value)"
        class="border-0 w-1/3 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring-2 focus:ring-primary-500 ease-linear transition-all duration-150">
        <option *ngFor="let item of countryList | async as list" [selected]="selectedCode == item.code"
            [value]="item.code">
            {{item.emoji}} {{item.dialCodes[0]}} {{item.name}}</option>
    </select>
    <input type="text" formControlName="phoneCode" name="phoneCode" hidden>
    <input type="text" formControlName="contact" name="contact" placeholder="Phone Number"
        class="flex-grow w-2/3 border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring-2 focus:ring-primary-500 ease-linear transition-all duration-150">
</div>
<div
    class="{{contactForm.invalid && (contactForm.dirty || contactForm.touched) ? 'visible' : 'invisible' }} pt-1 h-5 text-red-500 text-xs">
    <p *ngIf="contactForm.errors?.['invalidFormat']">Invalid E164
        phone
        format</p>
</div>